import { render, staticRenderFns } from "./nutritionalRecipe.vue?vue&type=template&id=33b61dbb&scoped=true&"
import script from "./nutritionalRecipe.vue?vue&type=script&lang=js&"
export * from "./nutritionalRecipe.vue?vue&type=script&lang=js&"
import style0 from "./nutritionalRecipe.vue?vue&type=style&index=0&id=33b61dbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b61dbb",
  null
  
)

export default component.exports